import type { CollectorAvatar } from "@/lib/ratings.functions";
import { cn } from "@/lib/utils";

/** Fotinhas empilhadas de quem tem o disco na coleção. */
export function CollectorsStack({
  people,
  count,
  className,
  labelClassName,
  size = 18,
}: {
  people: CollectorAvatar[];
  count: number;
  className?: string;
  labelClassName?: string;
  size?: number;
}) {
  if (count <= 0) return null;
  const shown = people.slice(0, 4);
  const rest = count - shown.length;
  return (
    <div className={cn("flex items-center gap-1.5", className)}>
      <div className="flex items-center">
        {shown.map((p, i) => (
          <img
            key={p.id}
            src={
              p.avatar_url ||
              `https://api.dicebear.com/7.x/initials/svg?seed=${p.username}`
            }
            alt={p.display_name ?? p.username}
            loading="lazy"
            decoding="async"
            width={size}
            height={size}
            style={{ width: size, height: size, marginLeft: i === 0 ? 0 : -6 }}
            className="rounded-full border border-background bg-muted object-cover"
          />
        ))}
      </div>
      <span className={cn("text-[11px] text-muted-foreground", labelClassName)}>
        {rest > 0 ? `+${rest}` : count}
      </span>
    </div>
  );
}
